import React from 'react';
import { addStyle } from '../utils';

export const getBackgroundField = (fields, isLight) =>
  isLight ? fields.BackgroundColourLight?.fields : fields.BackgroundColourDark?.fields;

export const addBackgroundColorVariables = (fields, styles) => {
  const backgroundColourLight = fields.BackgroundColourLight?.fields?.HexColorCode?.value;
  const backgroundColourDark = fields.BackgroundColourDark?.fields?.HexColorCode?.value;

  addStyle(styles, '--feature-background-color-light', backgroundColourLight);
  addStyle(styles, '--feature-background-color-dark', backgroundColourDark);

  addStyle(styles, '--feature-background-color-hover-light', backgroundColourLight);
  addStyle(styles, '--feature-background-color-hover-dark', backgroundColourDark);
};

export const getBackgroundColor = (fields, isLight) => {
  const backgroundColorLight = fields.BackgroundColourLight?.fields?.HexColorCode?.value;
  const backgroundColorDark = fields.BackgroundColourDark?.fields?.HexColorCode?.value;

  const backgroundColor = isLight ? backgroundColorLight : backgroundColorDark;

  return backgroundColor ?? 'transparent';
};

export default <></>;
